module.exports = __webpack_public_path__ + "static/media/delta_rise.f38ecd67.jpg";